<template>
  <span class="badge badge-pill" :class="currentStatus">
    {{statusText}}
  </span>
</template>

<script>
export default {
  name: "ProductStatus",
  props: ["status"],
  computed: {
    currentStatus() {
      switch (this.status) {
        case 'creating':
          return 'badge-warning';
        case 'updating':
          return 'badge-info';
        case 'completed':
          return 'badge-success';
        default:
          return 'badge-warning';
      }
    },
    statusText() {
      switch (this.status) {
        default:
          return this.status;
      }
    },
  },
};
</script>